export const styles = {
    ModalBackBtn: {
        cursor: 'pointer',
        transform: "rotate(90deg)",
        color: "#565656",
        marginTop: -3
    }
};
